module.exports = __webpack_public_path__ + "static/img/dk.372be1ea.png";